module.exports = __webpack_public_path__ + "img/product7.a7775c04.png";